<template>
  <button
    type="button"
    class="kakao-login-btn"
    :disabled="disabled || busy"
    @click="$emit('click')"
  >
    <span class="kakao-login-btn__icon" aria-hidden="true">
      <svg viewBox="0 0 24 24" width="18" height="18">
        <path
          fill="currentColor"
          d="M12 4C7.58 4 4 6.86 4 10.4c0 2.27 1.52 4.26 3.8 5.4l-.97 3.56c-.06.22.18.4.37.28l4.26-2.82c.18.01.35.02.54.02 4.42 0 8-2.86 8-6.44C20 6.86 16.42 4 12 4z"
        />
      </svg>
    </span>
    <span>{{ busy ? '카카오 연결 중...' : label }}</span>
  </button>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    label?: string
    busy?: boolean
    disabled?: boolean
  }>(),
  {
    label: '카카오로 로그인',
    busy: false,
    disabled: false,
  },
)

defineEmits<{
  click: []
}>()
</script>

<style lang="scss" src="./KakaoLoginButton.scss"></style>
